import {useQuery} from 'react-query';
import {LayerAttributeVO, UserLayersApi} from '../api';
import {LayerId} from '@mc/react-mapio';
import {CACHE_KEY_LAYER_ATTRIBUTES} from '../queryKeys';
import {useMapioContext} from '../mapioContext';

export const useLayerAttributes = (layerId: LayerId) => {
    const context = useMapioContext();

    return useQuery<LayerAttributeVO[]>(
        [CACHE_KEY_LAYER_ATTRIBUTES, layerId],
        async () => (await UserLayersApi.getLayerAttributes(layerId as number, context.value.context)).data,
        {
            enabled: Boolean(layerId),
            refetchOnWindowFocus: true,
            refetchOnReconnect: false,
            refetchOnMount: false,
        },
    );
};
